import styled from 'styled-components';
import CloudinaryImage from 'components/CloudinaryImage';
import { useMutation } from 'react-query';
import { SendApprovalRequest, sendCreatorApproval } from '../../queries/page';
import { useState } from 'react';
import { cloudinaryUrl } from 'services/cloudinary';
import { useWindowWidth } from '@react-hook/window-size';
import Text, { TypeVariant } from 'shared/Typography';
import TextInput from 'shared/TextInput';
import Button from 'shared/Button';
import Icon, { IconNames } from 'shared/Icons';

export const Container = styled.div<{ bgImage: string; width: number }>`
  display: flex;
  justify-content: space-evenly;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    background-image: ${({ bgImage }) => `url("${bgImage}")`};
    background-size: contain;
    background-position: 120% 28px;
    background-repeat: no-repeat;
  } ;
`;

export const WrapFirstSectionCol = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-left: 0px;
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
  } ;
`;

const DescriptionTextWrap = styled.div`
  padding-top: 30px;
  max-width: 400px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding: 0 25px;
    padding-top: 30px;
  }
`;

export const ImageWrap = styled.div`
  flex: 1;
  @media ${(p) => p.theme.queries.tabletAndDown} {
    display: none;
  } ;
`;

const FormContainer = styled.div`
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const InterestForm = () => {
  const [, setError] = useState<string | undefined>(undefined);
  const [email, setEmail] = useState<string>('');
  const [socialUrl, setSocialUrl] = useState<string>('');
  const [isSubmitting, seIsSubmitting] = useState<boolean>(false);
  const [isSubmitted, seIsSubmitted] = useState<boolean>(false);

  const handleSubmitCreatorApproval = useMutation(
    (data: SendApprovalRequest) => sendCreatorApproval(data),
    {
      onError: (err: any) =>
        setError(err?.message || 'Uh oh, we did not see that coming'),
    },
  );

  const handleSubmit = async () => {
    if (socialUrl.length === 0 && email.length === 0) {
      return null;
    }
    seIsSubmitting(true);
    seIsSubmitted(true);
    await handleSubmitCreatorApproval.mutateAsync({
      socialMediaUrl: socialUrl,
      email,
    });
    seIsSubmitting(false);
    setSocialUrl('');
    setEmail('');
  };

  return (
    <FormContainer>
      <TextInput
        label="Social Media URL"
        value={socialUrl}
        onChange={(val) => {
          setSocialUrl(val);
          if (isSubmitted) {
            seIsSubmitted(false);
          }
        }}
        variant="rounded"
        background="light"
      />
      <TextInput
        label="Email"
        value={email}
        onChange={(val) => {
          setEmail(val);
          if (isSubmitted) {
            seIsSubmitted(false);
          }
        }}
        variant="rounded"
        background="light"
        autoCapitalize={false}
      />

      <Button
        size="large"
        variant="fill"
        onClick={handleSubmit}
        disabled={!!!socialUrl || !!!email}
        fullWidth
        isLoading={isSubmitting}
      >
        {isSubmitted ? (
          <>
            <Icon id={IconNames.check} color="inherit" />
            <span style={{ marginLeft: 'var(--spacing-4)' }}>Submitted</span>
          </>
        ) : (
          'Submit'
        )}
      </Button>
    </FormContainer>
  );
};

const bgImage = cloudinaryUrl('pic1_1-removebg_1_p67vj1', 'auto', false);

const FirstSection = () => {
  const width = useWindowWidth({ initialWidth: 375 });
  return (
    <Container bgImage={bgImage} width={width}>
      <WrapFirstSectionCol>
        <Text
          variant={TypeVariant.header02}
          as="h2"
          color="var(--color-white)"
          tablet={TypeVariant.subtitle01}
          textAlign="center"
        >
          Our Hero
        </Text>

        <DescriptionTextWrap>
          <Text
            variant={TypeVariant.bodyLarge01}
            tablet={TypeVariant.body01}
            as="p"
            color="var(--color-white)"
            textAlign="center"
          >
            You inspire and keep us going, so let’s get your community talking
            about the amazing experiences they have
          </Text>
        </DescriptionTextWrap>
        <InterestForm />
      </WrapFirstSectionCol>
      <ImageWrap>
        <CloudinaryImage
          publicId="pic1_1-removebg_1_p67vj1"
          alt={'become creator main image'}
          width={500}
          height={690}
          quality={'auto:best'}
          fetchFormat={'auto'}
          crop={'scale'}
        />
      </ImageWrap>
    </Container>
  );
};

export default FirstSection;
